module.exports = __webpack_public_path__ + "img/googleplay.be03d56c.png";